import { Dialog, DialogContent, useTheme } from '@mui/material';
import { FormProvider, useFormState } from 'react-hook-form';

import DialogBackNextActions from '~/components/DialogBackNextActions';
import DialogTitleWithCloseButton from '~/components/DialogTitleWithCloseButton';
import {
  useViolationForm,
  ViolationFields,
  ViolationForm,
  ViolationFormData,
} from '~/components/uploadDocument/violationForm';
import { useLocaleTerms } from '~/hooks/useLocaleTerms';

interface IAddViolationDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data?: ViolationFormData) => void;
  isEdit?: boolean;
  defaultValues?: ViolationFormData;
  violationId?: string;
}

const AddViolationDialog = ({
  open,
  onClose,
  onSubmit,
  isEdit,
  defaultValues,
  violationId,
}: IAddViolationDialogProps) => {
  const theme = useTheme();
  const terms = useLocaleTerms();
  const { hookForm } = useViolationForm();
  const { isSubmitting } = useFormState({ control: hookForm.control });

  const actionBtns = {
    next: { label: isSubmitting ? 'Saving' : 'Save', enabled: !isSubmitting },
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <FormProvider {...hookForm}>
        <ViolationForm onSubmit={onSubmit} initialData={defaultValues} violationId={violationId}>
          <DialogTitleWithCloseButton
            onClose={onClose}
            title={`${isEdit ? 'Edit' : 'Add'} ${terms.violation}`}
          />
          <DialogContent
            sx={{ padding: theme.spacing(2), paddingTop: 0, overflow: 'auto', height: '100%' }}
          >
            <ViolationFields />
          </DialogContent>
          <DialogBackNextActions onBack={onClose} actionBtns={actionBtns} />
        </ViolationForm>
      </FormProvider>
    </Dialog>
  );
};

export default AddViolationDialog;
